import React from "react";
import { CheckCircle, Circle } from "phosphor-react";

export default function PriceCardFeature({ text, isAvailable }) {
  const featureClass = isAvailable ? "" : "opacity-50";

  return (
    <div className={`flex items-center mb-2 ${featureClass}`}>
      <div className="text-primary text-xs mr-2">
        {isAvailable ? (
          <CheckCircle size={20} weight="fill" color="#7fec93" />
        ) : (
          <Circle size={20} color="#7fec93" />
        )}
      </div>
      <p className="sm:text-base text-sm">{text}</p>
    </div>
  );
}
